import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { Container, Col, Row, Spinner} from 'react-bootstrap';
import AddSubscription from './Subscription/AddSubscription';
import CancelSubscription from './Subscription/CancelSubscription';
import AddPayment from './Subscription/AddPayment';
import EditPayment from './Subscription/EditPayment';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import AddCard from './Cards/AddCard';
import DeleteCard from './Cards/DeleteCard';
import { diplayCreditCard } from './Cards/Utils';
import { formatDate } from '../../utils';
import config from '../../config/config';
import * as CustomerApi from '../../Services/CustomerApi';
import EditSubscriptionNote from './Subscription/EditSubscriptionNote';
import { Button, Stack, Typography, Grid, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import {siteTheme} from '../../Components/SiteTheme';
import ChangeSubscription from './Subscription/ChangeSubscription';
import ConfirmationPopup from './Subscription/confirmationPopup';
import { Alert } from "react-bootstrap";
import { useLocation, useHistory } from 'react-router-dom';


//const stripePromise = loadStripe(config.stripeAusPublicKey);

const getStripeKey = (profile)=>{
    const account = profile?.accounts?.[0];
    console.log(profile);
    let key;
    if(account){
        key = account?.integrationIdentifier === "US" ? config.stripeUsPublicKey : config.stripeAusPublicKey;
    }else if(profile?.location?.countryName){
        key = profile?.location?.countryName === "United States" ? config.stripeUsPublicKey : config.stripeAusPublicKey;
    }
    return key;
}
function displayName(customer) {
    const firstName = customer.firstName === null ? '-' : customer.firstName;
    const lastName = customer.lastName === null ? '-' : customer.lastName;
    return firstName  + ' ' + lastName;
}


function CustomerProfile({customer, latestSubscription, loyaltyBalance, subscriptionTypes, subscriptionTiers,
    addSubscription, addSubscriptionPayment, editSubscriptionPayment, 
    cancelSubscription, editSubscriptionNote, cards, addCard, removeCard,
    changeSubscription,revertSubscription}) {
    
    const location = useLocation();
    const history = useHistory();
    const upcomingSubscription = latestSubscription?.upcomingSubscription;
    const [showSubsPopup, setShowSubsPopup] = useState(false);
    const [showCancelSubsPopup, setShowCancelSubsPopup] = useState(false);
    const [showPaymentPopup, setShowPaymentPopup] = useState(false);
    const [showEditPaymentPopup, setShowEditPaymentPopup] = useState(false);
    const [showCardPopup, setShowCardPopup] = useState(false);
    const [showChangeSubsPopup, setShowChangeSubsPopup] = useState(false);
    const [deleteCard, setDeleteCard] = useState(undefined);
    const [generating, setGenerating] = useState(false);
    const [showEditNotePopup, setshowEditNotePopup] = useState(false);
    const [stripePromise, setStripePromise] = useState(null);
    const [stripeKey, setStripeKey] = useState(null);
    const [noteType, setNoteType] = useState('ADD');
    const [reverting,setReverting] = useState(false)
    const [showRevertPopUp,setShowRevertPopUp] = useState(false)
    const [apiError, setApiError] = useState(undefined);

    const handleAddSubscription = async (data)=>{
        await addSubscription(data);
        setShowSubsPopup(false);
    }

    const handleCancelSubscription = async (data)=>{
       await cancelSubscription(data);
       setShowCancelSubsPopup(false);
    }

    const handleAddPayment = async (data)=>{
        await addSubscriptionPayment(data);
        setShowPaymentPopup(false);
    }

    const handleEditPayment = async (data)=>{
        await editSubscriptionPayment(data);
        setShowEditPaymentPopup(false);
    }

    const handleEditNote = async (data)=>{
        await editSubscriptionNote(data);
        setshowEditNotePopup(false);
    }

    const handleAddCard = async (data)=>{
        await addCard(data);
        setShowCardPopup(false);
    }

    const handleDeleteCard = async (data)=>{
        await removeCard(data);
        setDeleteCard(undefined);
    }



    const handleChangeSubscription = async (data)=>{
        await changeSubscription(data);
        setShowChangeSubsPopup(false);
    }

    const handleRevertSubscription = async(data)=>{
        try {
            await revertSubscription(
                {
                    oldUserSubscriptionId:data?.id,
                    upcomingSubscriptionRequestId:data?.upcomingSubscription?.requestId,
                }
                );
            setReverting(false);
        } catch (e) {
            setApiError(e?.message || "System error");
            setReverting(false);
            console.log(e)
        }
    }

    const subscriptionNotes = latestSubscription?.notes?.sort((a,b)=>b.updatedOn > a.updatedOn ? 1 : -1);
    const cancelNote = subscriptionNotes?.filter(note=>note.type === 'CANCEL');
    const addNote = subscriptionNotes?.filter(note=>note.type === 'ADD');
    const subsTimeZone = latestSubscription?.subscriptionType?.timezone;
    const subsCardId = latestSubscription?.subscriptionCard?.cardId;
    const subsCard = cards?.find(c => c.id === subsCardId);
    const subscriptionType = subscriptionTypes?.find(st => st.id === latestSubscription?.subscriptionType?.id);
    const isFreeSubs = subscriptionType?.value === 0;
    let isZeroValue = false;
    if(subscriptionType?.discountPercentage){
        isZeroValue = ((subscriptionType?.value *(100-subscriptionType?.discountPercentage))/100)===0;
    }

    const subscriptionTier = latestSubscription?.subscriptionType?.subscriptionTier;

    useEffect(()=>{
        const key = getStripeKey(customer?.profile);
        //console.log(key,customer?.profile);
        if(key){
            setStripePromise(loadStripe(key));
            setStripeKey(key);
        }else{
            setStripePromise(null);
            setStripeKey(null);
        }
    },[customer?.profile])

    const removeQueryParam = useCallback((param) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete(param);
        history.push({ search: searchParams.toString() });
      },[history, location.search])

    useEffect(()=>{
        const queryParams = new URLSearchParams(location.search);
        const action = queryParams.get('action');
        if(action === 'addCard'){
            setShowCardPopup(true);
            removeQueryParam('action')
        }
    },[location.search, removeQueryParam])

    return (
        <Elements key={stripeKey} stripe={stripePromise}>
        <div className="ModulePanel--wrapper CustomerProfile--wrapper">
            <Container fluid className='mb-5'>
                {/* <div className="PanelHeader d-flex justify-content-between"> */}
                <Stack direction="horizontal" display="flex" justifyContent="end" alignItems="center" flex="1">
                    <Box mt={siteTheme.spacing(8)}>
                <Button
                    variant='contained'
                    
                    onClick={async() => {
                        setGenerating(true);
                        try{
                            const data = await CustomerApi.generateLoginToken(customer?.profile?.email);
                            window.open(`${config.singularityUrl}/account/auto-login?authtoken=${data?.token}`, '_blank')
                            setGenerating(false);
                        }catch(err){
                            setGenerating(false);
                        }
                    }}
                    disabled = {generating}
                >
                {generating && <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />}
                    Login As
                </Button>
                </Box>
                </Stack>
                {/* </div> */}
                <div className="CustomerProfile CustomerProfile--PersonalRecord">
                    <Grid container spacing={2}>
                        <Grid item xs={3}><Typography variant="detailsDataLabel">Customer ID</Typography></Grid>
                        <Grid item xs={9}><Typography variant="detailsDataValue">{customer.profile.id}</Typography></Grid>
                    
                    
                        <Grid item xs={3}><Typography variant="detailsDataLabel">Name</Typography></Grid>
                        <Grid item xs={9}><Typography variant="detailsDataValue">{displayName(customer.profile)}</Typography></Grid>
                    
                    
                        <Grid item xs={3}><Typography variant="detailsDataLabel">Email</Typography></Grid>
                        <Grid item xs={9}><Typography variant="detailsDataValue">{customer.profile.email}</Typography></Grid>
                    
                    
                        <Grid item xs={3}><Typography variant="detailsDataLabel">Phone</Typography></Grid>
                        <Grid item xs={9}><Typography variant="detailsDataValue">{`${customer.profile.dialCode||''}${customer.profile.phone||''}`}</Typography></Grid>
                    
                    
                        <Grid item xs={3}><Typography variant="detailsDataLabel">Date of Birth</Typography></Grid>
                        <Grid item xs={9}><Typography variant="detailsDataValue">{customer.profile.dateOfBirth}</Typography></Grid>

                        <Grid item xs={3}><Typography variant="detailsDataLabel">location</Typography></Grid>
                        <Grid item xs={9}><Typography variant="detailsDataValue">{ customer?.profile?.location ? `${`${customer?.profile?.location?.cityName},` || ''} ${customer?.profile?.location?.countryName||''} `:''}</Typography></Grid>
                    
                    
                        <Grid item xs={3}><Typography variant="detailsDataLabel">Referral Code</Typography></Grid>
                        <Grid item xs={9}><Typography variant="detailsDataValue">{customer.profile.referralCode}</Typography></Grid>
                    
                    
                        <Grid item xs={3}><Typography variant="detailsDataLabel">Member Since</Typography></Grid>
                        <Grid item xs={9}><Typography variant="detailsDataValue">{moment(customer.profile.createdOn).format('DD-MM-YYYY')}</Typography></Grid>
                        </Grid>                    
                </div>
                <Box mt={siteTheme.spacing(10)}>
                <Container fixed className="CustomerProfile--Container" >
                    <Box className='CustomerProfile CustomerProfile--PointsdBalance' mb={siteTheme.spacing(10)}>
                        <Typography variant="h2" sx={{ position: 'relative', right: siteTheme.spacing(5) }} pb={siteTheme.spacing(4)}>
                            Points Balance</Typography>
                        {loyaltyBalance.length ?
                            loyaltyBalance.map((balance) => (
                                <Row key={balance.currencyCode} className="PointsBalance--wrapper">
                                    <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">{balance.currencyCode}</Typography></Col>
                                    <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{balance.pointsRemaining}</Typography></Col>
                                </Row>
                            )) :
                            <Row className="PointsBalance--wrapper">
                                <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">No Points Earned</Typography></Col>
                            </Row>
                        }
                    </Box>
                </Container>   
                <Container fixed className="CustomerProfile--Container">

                    {/* Customer Profile Subscription */}
                    <Box className='CustomerProfile CustomerProfile--Subscription'>
                    <Typography sx={{position: 'relative', right: siteTheme.spacing(5)}} variant="h2" pb={siteTheme.spacing(4)}>
                      {upcomingSubscription ? "Expiring Subscription" : "Active Subscription"}
                    </Typography>
                    {latestSubscription ? (<>
                        <Row className="PointsBalance--wrapper">
                            <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Tier</Typography></Col>
                            <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{subscriptionTier?.publicName || 'N.A'}</Typography></Col>
                        </Row>
                        <Row className="PointsBalance--wrapper">
                            <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Name</Typography></Col>
                            <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{latestSubscription?.subscriptionType?.name}</Typography></Col>
                        </Row>
                        {!upcomingSubscription && <Row className="PointsBalance--wrapper">
                            <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Status</Typography></Col>
                            <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{latestSubscription?.status}</Typography></Col>
                        </Row>}
                        {latestSubscription?.changeType && latestSubscription?.changeType !== 'CANCELLED' && <Row className="PointsBalance--wrapper">
                            <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Change Type</Typography></Col>
                            <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{latestSubscription?.changeType}</Typography></Col>
                        </Row>}
                        {!upcomingSubscription && <Row className="PointsBalance--wrapper">
                            <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Start Date</Typography></Col>
                            <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{formatDate(latestSubscription?.startDate, subsTimeZone, "DD MMM YYYY z")}</Typography></Col>
                        </Row>}

                        {latestSubscription.status === "ACTIVE" && (
                            <>
                                <Row className="PointsBalance--wrapper">
                                    <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Next Billing Date</Typography></Col>
                                    <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{formatDate(moment(latestSubscription?.validityEndDate).add(1,'day').format("YYYY-MM-DDTHH:mm:ssZ"), subsTimeZone, "DD MMM YYYY z")}</Typography></Col>
                                </Row>
                                {subsCard && (
                                    <Row className="PointsBalance--wrapper">
                                        <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Card</Typography></Col>
                                        <Col className="PointsBalance--Amount" style={Object.assign({},{cursor: 'pointer'})} onClick={() => setShowEditPaymentPopup(true)} ><Typography variant="detailsDataValue"><EditIcon fontSize="sm" />  {diplayCreditCard(subsCard)}</Typography></Col>
                                    </Row>
                                )}
                                {!subsCard && (
                                    <Row className="PointsBalance--wrapper">
                                        <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Card</Typography></Col>
                                        <Col className="PointsBalance--Amount" style={Object.assign({},{cursor: 'pointer'})} onClick={() => setShowEditPaymentPopup(true)} ><Typography variant="detailsDataValue"><EditIcon fontSize="sm" />  NA</Typography></Col>
                                    </Row>
                                )}
                                {addNote && <Row className="PointsBalance--wrapper">
                                    <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Notes</Typography></Col>
                                    <Col className="PointsBalance--Amount" style={Object.assign({},{cursor: 'pointer'})} onClick={() => {setshowEditNotePopup(true);setNoteType('ADD');}} ><Typography variant="detailsDataValue"><EditIcon fontSize="sm" />  {addNote[0]?.notes}</Typography></Col>
                                </Row>}
                            </>
                        )}
                        {latestSubscription.status === "CANCELLED" && (
                            <>
                                <Row className="PointsBalance--wrapper">
                                    <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">
                                        {upcomingSubscription ? "Change Date" : "End Date"}
                                    </Typography></Col>
                                    <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{formatDate(latestSubscription?.endDate, subsTimeZone, "DD MMM YYYY z")}</Typography></Col>
                                </Row>
                                <Row className="PointsBalance--wrapper">
                                    <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">
                                    {upcomingSubscription ? "Expiry Date" : "Validity Date"}
                                    </Typography></Col>
                                    <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{formatDate(latestSubscription?.validityEndDate, subsTimeZone, "DD MMM YYYY z")}</Typography></Col>
                                </Row>
                                {cancelNote && <Row className="PointsBalance--wrapper">
                                    <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">
                                    {upcomingSubscription ? "Change Notes" : "Cancel Notes"}
                                       
                                    </Typography></Col>
                                    <Col className="PointsBalance--Amount" style={Object.assign({},{cursor: 'pointer'})} onClick={() => {setshowEditNotePopup(true);setNoteType('CANCEL');}} ><Typography variant="detailsDataValue"><EditIcon fontSize="sm" /> {cancelNote[0]?.notes}</Typography></Col>
                                </Row>}
                            </>
                        )}
                        <Row className="PointsBalance--wrapper">
                            {(latestSubscription.status !== "CANCELLED") ? (
                                <>
                                    <Col>
                                        <div>
                                            <Button variant="contained" color="secondary"  onClick={()=>setShowCancelSubsPopup(true)} >Cancel</Button>
                                            <Button variant="contained" className='mx-3' onClick={()=>setShowChangeSubsPopup(true)}>Change Subscription</Button>
                                        </div>
                                    </Col>
                                    {!isFreeSubs && !isZeroValue && <Col><Button variant="contained" onClick={() => setShowPaymentPopup(true)} >Add Payment</Button></Col>}
                                </>
                            ):(
                                <>
                                    {!upcomingSubscription && <Col><Button variant="contained" onClick={()=>setShowSubsPopup(true)}>Add Subscription</Button></Col>}
                                </>
                                    
                            )}
                        </Row>
                    </>) : (
                        <Row className="PointsBalance--wrapper align-items-center">
                          <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">No Active Subscription</Typography></Col>
                          <Col><Button variant="contained" onClick={()=>setShowSubsPopup(true)}>Add Subscription</Button></Col>
                        </Row>
                    )}
                    </Box>
                    {showSubsPopup && <AddSubscription
                        show={showSubsPopup}
                        customer={customer}
                        subscriptionTypes={subscriptionTypes}
                        subscriptionTiers={subscriptionTiers}
                        cards={cards}
                        handleClose={() => setShowSubsPopup(false)}
                        handleSuccess={handleAddSubscription}
                        stripeKey={stripeKey}
                    />}
                    {showCancelSubsPopup && <CancelSubscription
                        show={showCancelSubsPopup}
                        customer={customer}
                        subscription={latestSubscription}
                        handleClose={() => setShowCancelSubsPopup(false)}
                        handleSuccess={handleCancelSubscription}
                    />}
                    {showPaymentPopup && <AddPayment
                        show={showPaymentPopup}
                        customer={customer}
                        cards={cards}
                        subscription={latestSubscription}
                        subscriptionTypes={subscriptionTypes}
                        handleClose={() => setShowPaymentPopup(false)}
                        handleSuccess={handleAddPayment}
                        stripeKey={stripeKey}
                    />}
                    {showEditPaymentPopup && <EditPayment
                        show={showEditPaymentPopup}
                        customer={customer}
                        cards={cards}
                        subscription={latestSubscription}
                        subsCard={subsCard}
                        subscriptionTypes={subscriptionTypes}
                        handleClose={() => setShowEditPaymentPopup(false)}
                        handleSuccess={handleEditPayment}
                        stripeKey={stripeKey}
                    />}
                    {showEditNotePopup && <EditSubscriptionNote
                        show={showEditNotePopup}
                        handleClose={() => setshowEditNotePopup(false)}
                        subscription={latestSubscription}
                        handleSuccess={handleEditNote}
                        noteType={noteType}
                    />}
                    {showChangeSubsPopup && <ChangeSubscription
                        show={showChangeSubsPopup}
                        customer={customer}
                        cards={cards}
                        subscription={latestSubscription}
                        subscriptionTypes={subscriptionTypes}
                        subscriptionTiers={subscriptionTiers}
                        handleClose={() => setShowChangeSubsPopup(false)}
                        handleSuccess={handleChangeSubscription}
                        stripeKey={stripeKey}
                    />}
                </Container>
               {upcomingSubscription && <Container fixed className="CustomerProfile--Container" >
                    <Box className='CustomerProfile CustomerProfile--Subscription' mt={siteTheme.spacing(10)}>
                        <Typography sx={{ position: 'relative', right: siteTheme.spacing(5) }} variant="h2" pb={siteTheme.spacing(4)}>
                            Upcoming Subscription
                        </Typography>
                        <Row className="PointsBalance--wrapper">
                            <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Tier</Typography></Col>
                            <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">
                                {upcomingSubscription?.subscriptionType?.subscriptionTier?.name || 'N.A'}
                            </Typography></Col>
                        </Row>
                        <Row className="PointsBalance--wrapper">
                            <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Name</Typography></Col>
                            <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{upcomingSubscription?.subscriptionType?.name}</Typography></Col>
                        </Row>
                        <Row className="PointsBalance--wrapper">
                            <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">Start Date</Typography></Col>
                            <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">
                                {formatDate(moment(upcomingSubscription?.changeSubscriptionOn).add(1,'day').format("YYYY-MM-DDTHH:mm:ssZ"), 
                                upcomingSubscription?.subscriptionType?.timezone, "DD MMM YYYY z")}
                            </Typography></Col>
                        </Row>
                        {latestSubscription?.changeType && latestSubscription?.changeType === 'DOWNGRADE' &&
                            <Row className="PointsBalance--wrapper">
                                <div>
                                    <Button variant="contained" className='mx-1' disabled={reverting} onClick={()=>{
                                        setShowRevertPopUp(true)                                        }}>
                                        {reverting && <Spinner
                                            as="span"
                                            animation="grow"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />}
                                        Cancel Change</Button>
                                </div>
                                <div style={{marginTop:'20px',display:'flex',alignItem:'center',justifyContent:'start'}}>
                                {apiError && (
                                    <Alert variant="danger">{apiError}</Alert>
                                )}
                                </div>
                            </Row>  
                              
                        }
                    </Box>
                    {showRevertPopUp && <ConfirmationPopup
                        show={showRevertPopUp}
                        handleClose={() => setShowRevertPopUp(false)}
                        handleSuccess={() =>{
                        setReverting(true)
                        setShowRevertPopUp(false)
                        handleRevertSubscription(latestSubscription)
                        }}
                    />}
                </Container>}
                </Box>
                
                <Container fluid className="CustomerProfile CustomerProfile--Subscription mt-3">
                    
                <Typography sx={{position: 'relative', right: siteTheme.spacing(5)}} variant="h2" pb={siteTheme.spacing(4)}>Active Cards</Typography>
                    <Row className="PointsBalance--wrapper">
                        {cards && cards.map(card=>(
                            <Row key={card?.id}>
                                <Col md={12} style={{
                                        borderBottom: '1px solid #b1b4ba',
                                        marginBottom: 15,
                                        paddingBottom: 5
                                }}>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <span><Typography variant="detailsDataValue">{diplayCreditCard(card)}</Typography></span>
                                        <Button 
                                            variant="contained" color="secondary" 
                                            onClick={()=>setDeleteCard(card)}
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        ))}
                        {(cards && cards.length === 0) && (
                            <Col className="PointsBalance--Amount">No Active Cards</Col>
                        )}
                    </Row>
                    <Row className="PointsBalance--wrapper">
                        <Col>
                            <Button 
                                variant="contained" 
                                onClick={()=>setShowCardPopup(true)}
                            >
                                Add Card
                            </Button>
                        </Col>
                    </Row>
                    {showCardPopup && <AddCard
                        show={showCardPopup}
                        customer={customer}
                        handleClose={() => setShowCardPopup(false)}
                        handleSuccess={handleAddCard}
                        stripeKey={stripeKey}
                    />}
                     {deleteCard && <DeleteCard
                        show={!!deleteCard}
                        customer={customer}
                        card={deleteCard}
                        handleClose={() => setDeleteCard(undefined)}
                        handleSuccess={handleDeleteCard}
                    />}
                </Container>
            </Container>
            </div>
        </Elements>
    )
}

export default CustomerProfile;